import { ScheduledContentEntry } from '../models/promotions';

/**
 * Returns the `content` of the scheduled entry whose `effectiveAt` is the most
 * recent one at or before `now`. Returns `null` when there are no active entries
 * (empty input or all entries are in the future).
 *
 * Tie-breaking is stable: when multiple active entries share the same
 * `effectiveAt`, the one occurring last in the input array wins.
 */
export function selectActiveScheduledContent(entries: ScheduledContentEntry[], now: Date = new Date()): string | null {
  if (entries.length === 0) {
    return null;
  }

  const nowMs = now.getTime();

  let activeContent: string | null = null;
  let activeEffectiveMs = Number.NEGATIVE_INFINITY;

  for (const entry of entries) {
    const entryMs = new Date(entry.effectiveAt).getTime();
    // Active = effective at or before `now`. On ties (`>=`) the later entry in
    // array order wins, giving stable, deterministic output.
    if (entryMs <= nowMs && entryMs >= activeEffectiveMs) {
      activeEffectiveMs = entryMs;
      activeContent = entry.content;
    }
  }

  return activeContent;
}
